import { Box, Tab, Tabs } from "@mui/material";
import Buttons from "./buttons/buttons";
import GridButtons from "./buttons/grid-buttons";
import NurseButtons from "./buttons/nurse-buttons";
import { useState } from "react";
import OtherButtons from "./buttons/other-buttons";
import Components from "./components/components";

function AdminTools() {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <>
            {children}
          </>
        )}
      </div>
    );
  }

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label=""
        >
          <Tab label="Butonlar" />
          <Tab label="Diğer" />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Buttons />
          <NurseButtons />
          <GridButtons />
          <OtherButtons />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Components />
        </TabPanel>
      </Box>
    </>
  );
}

export default AdminTools;
